import { render, staticRenderFns } from "./IngresoIndex.vue?vue&type=template&id=0666edd9&scoped=true&"
import script from "./IngresoIndex.vue?vue&type=script&lang=ts&"
export * from "./IngresoIndex.vue?vue&type=script&lang=ts&"
import style0 from "./IngresoIndex.vue?vue&type=style&index=0&id=0666edd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0666edd9",
  null
  
)

export default component.exports